import React from 'react';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import { APP_URL, S3_MP4_URL } from '../../constants';

import styles from './SupportBlock.scss';

const SupportBlock = () => {
  const { isDesktop } = useLayoutContext();

  const downloadClick = (event) => {
    event.preventDefault();
    metrics('SOLAR_LANDING_INSTALL_BUTTON', { trigger: 'support block' });
    window.open(APP_URL);
  };

  return (
    <div className={styles.supportBlock}>
      <div className={styles.title}>
        <FadeIn>
          <span>AI-powered</span>
        </FadeIn>
        <FadeIn delay={1}>
          <span className={styles.titleThin}>customer care</span>
        </FadeIn>
      </div>

      <FadeIn className={styles.description} delay={1.5}>
        <span>One-tap travel chat support</span>
      </FadeIn>

      <FadeIn delay={0.5}>
        <video
          className={styles.chatVideo}
          autoPlay={true}
          preload="auto"
          loop={true}
          muted={true}
          playsInline={true}
        >
          <source
            src={isDesktop ? `${S3_MP4_URL}chat_desktop.mp4` : `${S3_MP4_URL}chat_mobile.mp4`}
            type="video/mp4"
          />
        </video>
      </FadeIn>

      {!isDesktop && (
        <GradientButton
          className={styles.downloadButton}
          darkGradient={true}
          onClick={downloadClick}
        >
          Download app
        </GradientButton>
      )}
    </div>
  );
};

export default SupportBlock;
